import React from 'react';
export default function ChevronRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '20'}
      height={props.height ?? '20'}
      {...props}
    >
      <path
        d="M7.64111 14.7331L12.3611 9.99911L7.64111 5.26611"
        stroke={props.stroke ?? '#909090'}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
